<div class="clrweb-error-block">
    <div class="logo-block"><img src="../../../assets/logo_lg.png" /></div>
    <p class="error-code">404</p>
    <clr-icon shape="home" class="is-solid c-hand home" size="64" (click)="backToHome()"></clr-icon>
</div>
